import { action, get } from "@ember/object"
import Component from "@glimmer/component"
import type {
  CardAttachment,
  CardGoogleClassroom,
  ShareModeSettings,
} from "@shared/models/card-stack"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"
import { includes, isNil } from "lodash-es"
import { tracked } from "tracked-built-ins"
import styles from "./attachment.module.css"

interface Signature {
  Args: {
    card: CardGoogleClassroom
    attachment: CardAttachment
    planbookId: string
    removeAttachment: (cardId: string, attachment: CardAttachment) => void
    changeShareMode: (attachment: CardAttachment, shareMode: ShareModeSettings) => void
    cannotEditAttachments: boolean
  }
}

export default class GoogleClassroomAttachmentComponent extends Component<Signature> {
  readonly styles = styles
  @use googleDriveFile = new FindDoc(() => {
    if (this.isFromGoogle) {
      let regex = new RegExp("/d/(?<google_id>.*)/.*")
      let match = this.args.attachment.url.match(regex)
      if (match) {
        return ["google-drive-file", `${this.args.planbookId}:${match[1]}`, true]
      }
    }
    return ["google-drive-file", null]
  })

  shareModeOptions = [
    { value: "VIEW", humanized: "Students can view" },
    { value: "EDIT", humanized: "Students can edit" },
    { value: "STUDENT_COPY", humanized: "Make a copy for each student" },
  ]
  @tracked canShowShareModeMenu: boolean = false

  get isFromGoogle() {
    return (
      (includes(this.args.attachment.url, "docs.google.com") &&
        !includes(this.args.attachment.url, "docs.google.com/forms")) ||
      includes(this.args.attachment.url, "drive.google.com")
    )
  }

  get selectedShareMode(): ShareModeSettings | null {
    // @ts-ignore this is a getter problem that will go away with deep tracking
    if (isNil(get(this.args, "card.attributes.attachmentSettings"))) return "STUDENT_COPY"
    // @ts-ignore this is a getter problem that will go away with deep tracking
    let shareModeSetting: null | undefined | { shareMode: ShareModeSettings } = get(
      this.args,
      // @ts-ignore this is a getter problem that will go away with deep tracking
      `card.attributes.attachmentSettings.${this.args.attachment.id}`
    )
    return isNil(shareModeSetting) || isNil(shareModeSetting.shareMode)
      ? "STUDENT_COPY"
      : shareModeSetting.shareMode
  }

  @action
  toggleChangeShareModeMenu() {
    this.canShowShareModeMenu = !this.canShowShareModeMenu
  }
}
